import parametrizacao from './parametrizacao'

export default [
    ...parametrizacao,
]